import axios from 'axios'
import qs from 'qs'
import {
    Message
} from 'element-ui'
let _axiosInstance = axios.create({
    timeout: 10000,
    responseType: 'json',
    // withCredentials: true, // 是否允许带cookie这些
    transformRequest: [function (data, res, n) {
        // 对 data 进行任意转换处理
        return qs.stringify(data)
    }]
})
// _axiosInstance.interceptors.request.use(config =>{
//     return config
// })

_axiosInstance.interceptors.response.use(res => {
    let resData = res.data
    const {status_code} = resData
    switch (status_code) {
      case 200:
      resData  = resData.data
      break;
      default:
      return false
      break
    }
    return resData
})

/** 
 * @desc 请求之前的数据转化
 * @param {String} methods 请求方式
 * @param {String} url 接口地址
 * @param {Object} data 请求数组
 * @return 返回axios
 */

const axiosInstance = (method, url, data) => {
    let params = {
        client: 'h5',
        version: "1.2.0"
    }
    if (params) {
        Object.assign(params, data)
        if (typeof method === 'string') {
            if (method.toLowerCase() === 'get') {
                params = {
                    params: params
                }
            }
        }
    }
    return _axiosInstance[method](url, params)
}

export default axiosInstance